export default "__VITE_ASSET__CtVjRy7l__"